module.exports = __webpack_public_path__ + "static/media/hepsiburada.879ec3f9.webp";